/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInAccountResponseAccountType } from './linkedInAccountResponseAccountType';
import type { LinkedInAccountResponsePendingCheckpointType } from './linkedInAccountResponsePendingCheckpointType';
import type { LinkedInAccountResponseStatus } from './linkedInAccountResponseStatus';
import type { LinkedInUsageEntry } from './linkedInUsageEntry';

/**
 * Read schema. NEVER expose ``unipile_account_id``,
 * ``unipile_account_secret_enc``, ``linkedin_provider_id``, or any
 * pending-checkpoint internal id.
 */
export interface LinkedInAccountResponse {
  id: string;
  status: LinkedInAccountResponseStatus;
  account_type: LinkedInAccountResponseAccountType;
  display_name?: string | null;
  linkedin_handle?: string | null;
  default_signature_id?: string | null;
  default_signature_name?: string | null;
  inmail_credits_premium?: number;
  inmail_credits_recruiter?: number;
  inmail_credits_sales_navigator?: number;
  inmail_credits_synced_at?: string | null;
  pending_checkpoint_type?: LinkedInAccountResponsePendingCheckpointType;
  pending_checkpoint_expires_at?: string | null;
  connected_at?: string | null;
  today_usage?: LinkedInUsageEntry[];
}
